export const appSetting = {
  role: {
    ['admin']: {
      create: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'Yes',
        theme: 'Yes',
        import_calendar: 'Yes',
        upload_calendar: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'Yes',
        banner: 'Yes',
        wording: 'Yes',
        all_list: 'Yes',
        tags: 'Yes',
        club_date: 'Yes',
        member_list: 'Yes',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes',
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'Yes',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'Yes',
        all_list: 'Yes',
        tags: 'Yes',
        banner_mobile: 'Yes',
        email_mobile: 'Yes',
        club_date: 'Yes',
        member_list: 'Yes',
      },
      authorization: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'Yes',
        banner: 'Yes',
        all_list: 'Yes',
        tags: 'Yes',
        club_date: 'Yes',
        member_list: 'Yes',
      },
    },
    ['member']: {
      create: {
        event: 'Yes', // To Create Event
        message: 'Yes', // to Create message
        appointments: 'No', // To create or add appointments / birthdays etc
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'No',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes', // For Club Date (birthdays etc)
        member_list: 'No',
      },
      participate: {
        event: 'Yes', // To View Events
        message: 'Yes', // to View message
        appointments: 'Yes', // To View appointments / birthdays etc
        group: 'Yes', // To View Group
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes', // For Personal Email messages
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'No',
        chat: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['guest']: {
      create: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'No',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        contact_admin: 'Yes',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'No',
        tags: 'No',
        club_date: 'No',
        member_list: 'No',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'Yes',
        chat: 'No',
        personal_message: 'Yes',
        club_message: 'No',
        group_message: 'No',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'No',
        room: 'No',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'No',
        crm_news: 'No',
        banner: 'No',
        all_list: 'No',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'No',
        member_list: 'No',
      },
      authorization: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        all_list: 'No',
        tags: 'No',
        club_date: 'No',
        member_list: 'No',
      },
    },
    ['secretary']: {
      create: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes',
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['functionary']: {
      create: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes',
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'Yes',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'No',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['editor']: {
      create: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes',
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'No',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['user']: {
      create: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'No',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'No',
        chat: 'Yes',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'No',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'Yes',
        chat: 'Yes',
        personal_message: 'Yes',
        club_message: 'Yes',
        group_message: 'Yes',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'Yes',
        organizer_currentStatus: 'Yes',
        organizer_archivedDocument: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        crm_survey: 'Yes',
        crm_news: 'Yes',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'Yes',
        message: 'Yes',
        appointments: 'Yes',
        group: 'Yes',
        news: 'Yes',
        task: 'Yes',
        subtask: 'Yes',
        document: 'No',
        chat: 'Yes',
        course: 'Yes',
        instructor: 'Yes',
        room: 'Yes',
        survey: 'Yes',
        faq: 'Yes',
        category: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['member_light']: {
      create: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'No',
        task: 'No',
        subtask: 'No',
        document: 'NO',
        chat: 'No',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        personal_message: 'No',
        club_message: 'No',
        group_message: 'No',
        organizer_myDocument: 'No',
        organizer_clubDocument: 'No',
        organizer_currentStatus: 'No',
        organizer_archivedDocument: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        crm_survey: 'No',
        crm_news: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'Yes',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
    ['member_light_admin']: {
      create: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'NO',
        chat: 'No',
        contact_admin: 'No',
        email: 'No',
        theme: 'No',
        import_calendar: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'No',
        wording: 'No',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      participate: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        personal_message: 'No',
        club_message: 'No',
        group_message: 'No',
        organizer_myDocument: 'Yes',
        organizer_clubDocument: 'No',
        organizer_currentStatus: 'No',
        organizer_archivedDocument: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        crm_survey: 'No',
        crm_news: 'No',
        banner: 'No',
        all_list: 'Yes',
        tags: 'No',
        banner_mobile: 'No',
        email_mobile: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
      authorization: {
        event: 'No',
        message: 'No',
        appointments: 'No',
        group: 'No',
        news: 'Yes',
        task: 'No',
        subtask: 'No',
        document: 'No',
        chat: 'No',
        course: 'No',
        instructor: 'No',
        room: 'No',
        survey: 'No',
        faq: 'No',
        category: 'No',
        banner: 'Yes',
        all_list: 'Yes',
        tags: 'No',
        club_date: 'Yes',
        member_list: 'No',
      },
    },
  },
  priorities: {
    low: 8,
    medium: 7,
    high: 2,
  },
  uploadDocument: {
    myDocument: ['admin', 'functionary'],
    clubDocument: ['admin', 'functionary'],
    currentStatus: ['admin', 'functionary'],
    archivedDocument: ['admin', 'functionary'],
  },
  documentVisibility: {
    clubDocument: '',
  },
  extensions: {
    sketch: 'assets/img/doc-icons/sketch.svg',
    folder: 'assets/img/doc-icons/folder.svg',
    zip: 'assets/img/doc-icons/folder.svg',
    psd: 'assets/img/doc-icons/psd.svg',
    ppt: 'assets/img/doc-icons/p.svg',
    pptx: 'assets/img/doc-icons/p.svg',
    png: 'assets/img/doc-icons/png_ic.png',
    jpg: 'assets/img/doc-icons/jpg_ic.png',
    jpeg: 'assets/img/doc-icons/jpg_ic.png',
    ai: 'assets/img/doc-icons/Ai.svg',
    pdf: 'assets/img/doc-icons/adobe.svg',
    docx: 'assets/img/doc-icons/word.svg',
    docs: 'assets/img/doc-icons/word.svg',
    txt: 'assets/img/doc-icons/word.svg',
    xls: 'assets/img/doc-icons/x.svg',
    xlsx: 'assets/img/doc-icons/x.svg',
  },
  imageType: ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp', 'avif', 'apng', 'jfif', 'pjpeg', 'pjp'],
  documentTypes: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'],
};
